export const filterTaskData = (taskData, textSearch) => {
    return taskData.filter(element => {
        if (textSearch.trim() === "") {
            return true
        }

        const text = textSearch.trim().toLowerCase().split(" ")
        const adaptData = d => d != null ? String(d).toLowerCase() : ""
        const fields = ["reference", "dni", "clientName", "refClient", "deviceName", "description",
                        "phone", "imei"]
        
        let rowData = fields.reduce((acc, value) => acc + adaptData(element[value]), "")

        return text.every(t => {
            if (text.length > 1 || t.length > 2) {
                const rowDataWithNumber = rowData + adaptData(element.number)
                return rowDataWithNumber.includes(t)
            }

            return rowData.includes(t)
        })
    })
}